import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedSidebarComponent } from "./med-sidebar.component";

@NgModule({
  declarations: [
    MedSidebarComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedSidebarComponent,
  ],
})
export class MedSidebarModule { }
